"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyncMpState = void 0;
var react_1 = require("react");
var useMultiProducts_1 = require("../../hooks/useMultiProducts");
var SyncMpState = function (props) {
    var setMpState = props.setMpState, _a = props.isSelected, isSelected = _a === void 0 ? false : _a;
    var _b = (0, useMultiProducts_1.useMultiProducts)({
        isSelected: isSelected,
    }), multiProducts = _b.multiProducts, isLoading = _b.isLoading;
    (0, react_1.useEffect)(function () {
        setMpState({ multiProducts: multiProducts, isLoading: isLoading });
    }, [multiProducts, isLoading, setMpState]);
    return null;
};
exports.SyncMpState = SyncMpState;
